export default "__VITE_ASSET__CuXb_FX7__"